import { useOverlayContext } from 'seagull';
import PaymentMethodLearnMoreModal from "./PaymentMethodLearnMoreModal";
import { jsx as _jsx } from "react/jsx-runtime";
export const usePaymentMethodLearnMoreModal = function usePaymentMethodLearnMoreModal() {
  let isDesktop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  const overlayContext = useOverlayContext();
  return () => {
    overlayContext.showModal({
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/_jsx(PaymentMethodLearnMoreModal, {
          isDesktop: isDesktop,
          dismissModal: dismissModal
        });
      },
      closeOnClickOutside: true,
      closeOnEscapeKey: true
    });
  };
};